export class CsvObjectMapper {
  public toObjects<T, R>(data: T[], objectMapping: CsvObjectMapping<T, R>) : R[] {
    if (data == undefined || data.length == 0) {
      return [] as R[];
    }
    return data.map(dataLine => {
      const objectItem = {} as R;
      for (const key in objectMapping) {
        const propertyMapping = objectMapping[key];
        if (propertyMapping) {
          objectItem[key] = propertyMapping(dataLine);
        }
      }
      return objectItem;
    })
  }
}

export type CsvObjectMapping<T, R> = {
  [K in keyof R]: (data: T) => R[K];
};
